import { render, staticRenderFns } from "./MoadianSubmissions.vue?vue&type=template&id=22389b5a&scoped=true"
import script from "./MoadianSubmissions.vue?vue&type=script&lang=js"
export * from "./MoadianSubmissions.vue?vue&type=script&lang=js"
import style0 from "./MoadianSubmissions.vue?vue&type=style&index=0&id=22389b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22389b5a",
  null
  
)

export default component.exports